import Scrollbar from 'react-scrollbars-custom';
import { Col, Row } from "react-bootstrap";
import React, { Component } from "react";

class ImageAuditModal extends Component {

    constructor(props) {
		super(props);
		this.onPressEsc = this.onPressEsc.bind(this);
	}
    
    componentDidUpdate() {
		document.addEventListener('keydown', this.onPressEsc, false);
	}

    onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

    onPressCancel() {
        this.setState(
			() => {
				this.props.handleCancel();
			}
		);
    }

    render() {
        return (
            <div className={this.props.imageAuditModalIsVisible ? "modal display-block" : "modal display-none"}>
                <Scrollbar style={{ width: '90%', height: '100%' }}>
                    <div className="modal-center-main">
                        <div className="auth-group">
                            <center>
                                <h2>AUDITORÍA DE IMAGEN {this.props.productImageSavedData ? this.props.productImageSavedData.no_sap : ''}</h2>
                            </center>
                            <div className="auth-label"></div>
                            <div className="auth-label"></div>
                            <br></br>
                            <Row>
				                <Col xs={12} md={12} sm={12} lg={12} style={{textAlign: 'left'}}>
                                    <Row>
                                        <Col xs={12} md={12} sm={12} lg={12} style={{textAlign: 'left'}}>
                                            <h3>Carga de imagen</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '18px'}}>Usuario:</Col>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '20px'}}>
                                            { 
                                                this.props.productImageSavedData && this.props.productImageSavedData.user_upload !== '' ?
                                                this.props.productImageSavedData.user_upload :
                                                '----------' 
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '18px'}}>Fecha de carga:</Col>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '20px'}}>
                                            { 
                                                this.props.productImageSavedData && this.props.productImageSavedData.upload_at !== null ?
                                                this.props.productImageSavedData.upload_at :
                                                '----------'
                                            }
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <Row>
                                        <Col xs={12} md={12} sm={12} lg={12} style={{textAlign: 'left'}}>
                                            <h3>Eliminación de imagen</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '18px'}}>Usuario:</Col>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '20px'}}>
                                            { 
                                                this.props.productImageSavedData && this.props.productImageSavedData.user_delete !== '' ?
                                                this.props.productImageSavedData.user_delete :
                                                '----------'
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '18px'}}>Fecha de eliminación:</Col>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '20px'}}>
                                            { 
                                                this.props.productImageSavedData && this.props.productImageSavedData.delete_at !== null ?
                                                this.props.productImageSavedData.delete_at :
                                                '----------'
                                            }
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <Row>
                                        <Col xs={12} md={12} sm={12} lg={12} style={{textAlign: 'left'}}>
                                            <h3>Actualización de registro</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '18px'}}>Fecha de actualización:</Col>
                                        <Col xs={6} md={6} sm={6} lg={6} style={{fontSize: '20px'}}>
                                            { 
                                                this.props.productImageSavedData && this.props.productImageSavedData.updated_at !== null ?
                                                this.props.productImageSavedData.updated_at :
                                                '----------'
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <br></br>
                            <div className="modal-activity-section">
                                {
                                    <button
                                        className = "modal-buttonNo"
                                        onClick   = {this.onPressCancel.bind(this)}
                                    >
                                        CERRAR
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </Scrollbar>
            </div>
        );
    }

}

export default ImageAuditModal;